export default __webpack_public_path__ + "static/media/logo_sergai.e6f5b7ae.png";